"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _input = require("@kyruus/input");
var _styles = require("./styles");
// NOTE: `resize` is in the list so that we can EXCLUDE that prop if it's passed in
/* eslint-disable react/display-name,no-unused-vars */
const TextArea = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    isResizable,
    resize,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_input.TextInputBase, props, TextInputProps => {
    return /*#__PURE__*/_react.default.createElement(_styles.StyledTextArea, (0, _extends2.default)({
      ref: ref,
      resize: isResizable ? 'vertical' : 'none'
    }, TextInputProps));
  });
});
TextArea.propTypes = {
  ..._input.TextInputBase.propTypes,
  /**
   * The boolean isResizable determines whether resize is set to "vertical" or "none".
   * See https://kyruus.jira.com/browse/KENG-13712
   */
  isResizable: _propTypes.default.bool,
  /**
   * Disabled textarea resize.
   * Note: pulled out resize from props to effectively disable it being passed in directly as a HTML attribute.
   * Instead, resize is controlled by the prop isResizable.
   */
  resize: (props, propName, componentName) => {
    if (props[propName]) {
      return new Error('Disabled prop `' + propName + '` supplied to' + ' `' + componentName + '`. Please use the prop `isResizable` to enable resizing (currently limited to vertical resizing).');
    }
  }
};
TextArea.defaultProps = {
  ..._input.TextInputBase.defaultProps,
  isResizable: false
};
var _default = exports.default = TextArea;
TextArea.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TextArea",
  "props": {
    "isResizable": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "The boolean isResizable determines whether resize is set to \"vertical\" or \"none\".\nSee https://kyruus.jira.com/browse/KENG-13712",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "resize": {
      "description": "Disabled textarea resize.\nNote: pulled out resize from props to effectively disable it being passed in directly as a HTML attribute.\nInstead, resize is controlled by the prop isResizable.",
      "type": {
        "name": "custom",
        "raw": "(props, propName, componentName) => {\n  if (props[propName]) {\n    return new Error(\n      'Disabled prop `' +\n        propName +\n        '` supplied to' +\n        ' `' +\n        componentName +\n        '`. Please use the prop `isResizable` to enable resizing (currently limited to vertical resizing).'\n    );\n  }\n}"
      },
      "required": false
    }
  },
  "composes": ["@kyruus/input"]
};